import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { FormulaValue } from '@tradecafe/types/core'
import type { DeepReadonly } from '@tradecafe/types/utils'
import { sortBy } from 'lodash-es'
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment

export type CreateFormulaValueDto = Omit<FormulaValue, 'formula_value_id' | 'created_at' | 'created_by' | 'updated_at' | 'updated_by'>

@Injectable()
export class FormulaValueApiService {
  private readonly http = inject(HttpClient)


  list() {
    return this.http
      .get<{ data: FormulaValue[] }>(`${apiUrl}/formula-value`)
      .pipe(map(r => sortBy(r.data, 'name')))
  }

  create(data: DeepReadonly<CreateFormulaValueDto>) {
    return this.http
      .post<{ data: FormulaValue }>(`${apiUrl}/formula-value`, data)
      .pipe(map(r => r.data))
  }

  get(id: string) {
    return this.http
      .get<{ data: FormulaValue }>(`${apiUrl}/formula-value/${id}`)
      .pipe(map(r => r.data))
  }

  update(id: string, data: DeepReadonly<Partial<CreateFormulaValueDto>>) {
    return this.http
      .put<{ data: FormulaValue }>(`${apiUrl}/formula-value/${id}`, data)
      .pipe(map(r => r.data))
  }

  delete(id: string) {
    return this.http
      .delete<{ data: FormulaValue }>(`${apiUrl}/formula-value/${id}`)
      .pipe(map(r => r.data))
  }
}
